<div class="template-generator-modal">
  <div class="modal-controls">
    <label for="modal-select">Choose a Modal: </label>
    <select id="modal-select" [(ngModel)]="selectedModalUUID">
      @for (modal of savedModals | orderBy:'name'; track modal) {
      <option [value]="modal.uuid">{{ modal.name }}</option>
      }
    </select>
    <button
      mat-flat-button
      (click)="saveModal()"
      [disabled]="!selectedModalUUID"
    >
      Save
    </button>
    <button mat-flat-button (click)="saveModalAsNew()">Save As New</button>
  </div>

  <mat-tab-group (selectedTabChange)="onModeChange($event)">
    <mat-tab label="Desktop">
      @if (getSelectedModal()) {
      <div class="modal-settings">
        <div class="modal-controls">
          <label for="copy-components-select-1">Copy Components From: </label>
          <select
            id="copy-components-select-1"
            [(ngModel)]="copyComponentsFromMode_mode"
          >
            @for (mode of [1, 2, 3]; track mode) {
            <option [value]="mode">
              {{ mode === 1 ? "Desktop" : mode === 2 ? "Tablet" : "Mobile" }}
            </option>
            }
          </select>
          <button
            mat-flat-button
            (click)="copyComponentsFromMode(1)"
            [disabled]="!selectedModalUUID"
          >
            Copy Components
          </button>
        </div>
        <div class="form-group">
          <label for="modalWidth1">Width:</label>
          <input
            id="modalWidth1"
            type="text"
            [(ngModel)]="getSelectedModal()!.settings['width'].value[1]"
            (ngModelChange)="updateGridsterSize()"
          />
        </div>
        <div class="form-group">
          <label for="modalHeight1">Height:</label>
          <input
            id="modalHeight1"
            type="text"
            [(ngModel)]="getSelectedModal()!.settings['height'].value[1]"
            (ngModelChange)="updateGridsterSize()"
          />
        </div>
        <div class="form-group">
          <label for="modalCSS1">Custom CSS:</label>
          <textarea
            id="modalCSS1"
            [(ngModel)]="getSelectedModal()!.settings['customCSS'].value[1]"
          ></textarea>
        </div>
      </div>
      }
    </mat-tab>
    <mat-tab label="Tablet">
      @if (getSelectedModal()) {
      <div class="modal-settings">
        <div class="modal-controls">
          <label for="copy-components-select-2">Copy Components From: </label>
          <select
            id="copy-components-select-2"
            [(ngModel)]="copyComponentsFromMode_mode"
          >
            @for (mode of [1, 2, 3]; track mode) {
            <option [value]="mode">
              {{ mode === 1 ? "Desktop" : mode === 2 ? "Tablet" : "Mobile" }}
            </option>
            }
          </select>
          <button
            mat-flat-button
            (click)="copyComponentsFromMode(2)"
            [disabled]="!selectedModalUUID"
          >
            Copy Components
          </button>
        </div>
        <div class="form-group">
          <label for="modalWidth2">Width:</label>
          <input
            id="modalWidth2"
            type="text"
            [(ngModel)]="getSelectedModal()!.settings['width'].value[2]"
            (ngModelChange)="updateGridsterSize()"
          />
        </div>
        <div class="form-group">
          <label for="modalHeight2">Height:</label>
          <input
            id="modalHeight2"
            type="text"
            [(ngModel)]="getSelectedModal()!.settings['height'].value[2]"
            (ngModelChange)="updateGridsterSize()"
          />
        </div>
        <div class="form-group">
          <label for="modalCSS2">Custom CSS:</label>
          <textarea
            id="modalCSS2"
            [(ngModel)]="getSelectedModal()!.settings['customCSS'].value[2]"
          ></textarea>
        </div>
      </div>
      }
    </mat-tab>
    <mat-tab label="Mobile">
      @if (getSelectedModal()) {
      <div class="modal-settings">
        <div class="modal-controls">
          <label for="copy-components-select-3">Copy Components From: </label>
          <select
            id="copy-components-select-3"
            [(ngModel)]="copyComponentsFromMode_mode"
          >
            @for (mode of [1, 2, 3]; track mode) {
            <option [value]="mode">
              {{ mode === 1 ? "Desktop" : mode === 2 ? "Tablet" : "Mobile" }}
            </option>
            }
          </select>
          <button
            mat-flat-button
            (click)="copyComponentsFromMode(3)"
            [disabled]="!selectedModalUUID"
          >
            Copy Components
          </button>
        </div>
        <div class="form-group">
          <label for="modalWidth3">Width:</label>
          <input
            id="modalWidth3"
            type="text"
            [(ngModel)]="getSelectedModal()!.settings['width'].value[3]"
            (ngModelChange)="updateGridsterSize()"
          />
        </div>
        <div class="form-group">
          <label for="modalHeight3">Height:</label>
          <input
            id="modalHeight3"
            type="text"
            [(ngModel)]="getSelectedModal()!.settings['height'].value[3]"
            (ngModelChange)="updateGridsterSize()"
          />
        </div>
        <div class="form-group">
          <label for="modalCSS3">Custom CSS:</label>
          <textarea
            id="modalCSS3"
            [(ngModel)]="getSelectedModal()!.settings['customCSS'].value[3]"
          ></textarea>
        </div>
      </div>
      }
    </mat-tab>
  </mat-tab-group>

  <div class="component-controls">
    <label for="component-select">Available Components: </label>
    <select id="component-select" [(ngModel)]="selectedCustomComponentName">
      @for (comp of templateGeneratorComponent.availableComponents | keyvalue;
      track comp) {
      <option [value]="comp.value.name">{{ comp.key }}</option>
      }
    </select>
    <button
      mat-flat-button
      (click)="
        templateGeneratorComponent.addComponentToModal(
          selectedCustomComponentName,
          getSelectedModal(),
          currentMode
        )
      "
    >
      Add Component
    </button>
  </div>

  @if (getSelectedModal()) {
  <div class="modal-preview">
    <div
      class="gridster-container"
      [attr.data-container-uuid]="selectedModalUUID"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
      <gridster [options]="gridOptions">
        @for (item of getSelectedModalComponents(); track item) {
        <gridster-item [item]="item">
          <div class="grid-item" [attr.data-uuid]="item.uuid">
            <div class="drag-handle">
              <div class="button-container">
                <button
                  id="edit_button"
                  (click)="$event.stopPropagation(); editComponent(item.uuid!)"
                >
                  E
                </button>
                <button
                  id="copy_button"
                  (click)="$event.stopPropagation(); copyComponent(item)"
                >
                  C
                </button>
                <button
                  id="delete_button"
                  (click)="
                    $event.stopPropagation(); removeComponent(item.uuid!)
                  "
                >
                  D
                </button>
              </div>
            </div>
            <div
              class="content-area"
              draggable="true"
              (dragstart)="onDragStart($event, item)"
              (dragend)="onDragEnd($event)"
            >
              <app-dynamic-component
                [customComponent]="item"
                [editorMode]="true"
              >
                @if (item.name === 'ComponentContainerComponent') {
                <div
                  class="gridster-drop-zone nested"
                  [attr.data-container-uuid]="item.uuid"
                  (dragenter)="onDragEnter($event)"
                  (dragleave)="onDragLeave($event)"
                  (dragover)="onDragOver($event)"
                  (drop)="onDrop($event)"
                ></div>
                }
              </app-dynamic-component>
            </div>
          </div>
        </gridster-item>
        }
      </gridster>
    </div>
  </div>
  }
</div>
